import { render, staticRenderFns } from "./ModalBlackjackRules.vue?vue&type=template&id=76d74f94&scoped=true"
import script from "./ModalBlackjackRules.vue?vue&type=script&lang=js"
export * from "./ModalBlackjackRules.vue?vue&type=script&lang=js"
import style0 from "./ModalBlackjackRules.vue?vue&type=style&index=0&id=76d74f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d74f94",
  null
  
)

export default component.exports